<script>
import FooterColumnLink from './FooterColumnLink';

export default {
  components: {
    FooterColumnLink,
  },
  props: {
    openDefault: [String, Boolean],
    title: String,
    links: Array,
    height: Number,
  },
  data: () => ({
    open: false,
  }),
  computed: {
    style() {
      let style = {};

      let sizes = ['sm', 'md'];

      if (this.open && sizes.includes(this.$mq)) {
        style.height = `${this.height}px`;
      } else if (!sizes.includes(this.$mq)) {
        style.height = 'auto';
      } else {
        style.height = 0;
      }

      return style;
    },
  },
  created() {
    if (this.openDefault) {
      this.open = true;
    }
  },
};
</script>

<template lang='pug'>
.w-full.md_w-auto.mt-2.mx-1.md_mt-0.md_mx-0
  .flex.items-center.justify-between.w-full.leading-tight.border-b.border-brand-secondary-800.px-1.cursor-pointer.pb-_5.md_pb-0.md_px-0.md_border-0.md_leading-loose.md_cursor-default(
    @click='open = !open',
    @keyup.enter='open = !open',
  )
    .text-2xl.text-brand.md_text-base.md_font-bold.select-none {{title}}
    .text-3xl.md_hidden.font-archivo
      svg(v-if='open', style='width:24px;height:24px', viewBox='0 0 24 24')
        path.text-brand-secondary-400.fill-current(d='M19,13H5V11H19V13Z')
      svg(v-else, style='width:24px;height:24px', viewBox='0 0 24 24')
        path.text-brand-secondary-400.fill-current(d='M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z')

  .flex.flex-col.pt-1.overflow-hidden.transition-250.transition-all.md_pt-0(:style='style')
    footer-column-link.ml-1.text-2xl.md_text-base.md_ml-0(v-for='link in links', :key='link.uri', :link='link')
</template>

<style>
@import '~import/index';
</style>